import Platform from"../../../exports/Platform";export default Platform;